module.exports = __webpack_public_path__ + "img/es_Beta Digitis - Gif.750400d1.gif";